/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ venueName: NonNullable<unknown> }} Venueflyertitle2Inputs */

const en_venueflyertitle2 = /** @type {(inputs: Venueflyertitle2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Live Room · ${i?.venueName}`)
};

const de_venueflyertitle2 = /** @type {(inputs: Venueflyertitle2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Live Room · ${i?.venueName}`)
};

/**
* | output |
* | --- |
* | "Live Room · {venueName}" |
*
* @param {Venueflyertitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const venueflyertitle2 = /** @type {((inputs: Venueflyertitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Venueflyertitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_venueflyertitle2(inputs)
	return de_venueflyertitle2(inputs)
});
export { venueflyertitle2 as "venueFlyerTitle" }